import { render, staticRenderFns } from "./PhotoGalleryComponent.vue?vue&type=template&id=200a389c&"
import script from "./PhotoGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./PhotoGalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhotoGalleryComponent.vue?vue&type=style&index=0&id=200a389c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports